import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const BelizeFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14371'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14371)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 12.1334H20V1.8667H0V12.1334Z'
					fill='#094995'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 1.86667H20V0H0V1.86667Z'
					fill='#D5182F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V12.1333H0V14Z'
					fill='#D5182F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M10.0006 11.2C12.3675 11.2 14.2863 9.31965 14.2863 7.00005C14.2863 4.68045 12.3675 2.80005 10.0006 2.80005C7.63362 2.80005 5.71484 4.68045 5.71484 7.00005C5.71484 9.31965 7.63362 11.2 10.0006 11.2Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99972 9.79995C11.5777 9.79995 12.8569 8.54635 12.8569 6.99995C12.8569 5.45355 11.5777 4.19995 9.99972 4.19995C8.42176 4.19995 7.14258 5.45355 7.14258 6.99995C7.14258 8.54635 8.42176 9.79995 9.99972 9.79995Z'
					stroke='#118014'
					strokeWidth='1.33333'
					strokeLinecap='round'
					strokeDasharray='0.67 2'
				/>
			</g>
		</svg>
	);
};

export default BelizeFlagIcon;
